import { CREATURE_ART, creaturePoster } from '~/data/art'
import { BOSS_ART } from '~/data/bossArt'
import { enemyArt } from '~/data/enemyArt'
import { assetUrl } from '~/utils/assetUrl'

/**
 * 📱 M3 (mobile gameplan): what to show when a creature, enemy or boss
 * LOOP cannot load - its creature's poster, the enemy's idle, the boss's
 * still, every one of which ships inside the apps (shared/starterSet.ts).
 * A face-off portrait falls back to its creature's poster. The stand-in is
 * the registry's own URL, busters and all, so it is the very file (and the
 * very cache entry) the rest of the game shows. null when there is nothing
 * lighter to try: a poster, a still, a silhouette, ui art.
 * plugins/art-fallback.client.ts applies it to every failed <img>.
 */
const CREATURE_BY_STEM = new Map(Object.entries(CREATURE_ART)
  .map(([id, path]) => [path.slice(path.lastIndexOf('/') + 1).replace(/\.webp$/, ''), id]))

export function artFallback(url: string): string | null {
  // currentSrc is absolute: the art host's, or the page's own origin
  // (https://localhost in the Android app) for a bundled file.
  const path = url.replace(/^[a-z][a-z0-9+.-]*:\/\/[^/]+/i, '').split('?')[0]!
  let m = /^\/creatures\/mood\/([a-z0-9-]+)-(?:calm|determined|hurt|angry)\.webp$/.exec(path)
    ?? /^\/creatures\/([a-z0-9-]+?)(?:-running|-victory|-defeat)?\.webp$/.exec(path)
  if (m) {
    const id = CREATURE_BY_STEM.get(m[1]!)
    return id ? creaturePoster(id) : null
  }
  m = /^\/enemies\/([a-z0-9-]+)-(?:victory|defeat)\.webp$/.exec(path)
  if (m) return enemyArt(m[1]!)
  m = /^\/bosses\/([a-z0-9-]+)-(?:idle|victory|defeat|showcase)\.webp$/.exec(path)
  if (m) {
    const still = BOSS_ART[m[1]!]
    return still ? assetUrl(still) : null
  }
  return null
}
